import Stack from '@mui/material/Stack';
import GlobalWrapper from '../../../components/Wrapper/GlobalWrapper';
import TutorManagementCardAndTable from './components/TutorManagementCard';
import GlobalDialog from '../../../components/mui/Dialogue/GlobalDialog';
import { useEffect, useMemo, useState } from 'react';
import SubjectWiseFreeSlot from './components/SubjectWiseFreeSlot';
import PreviousMonthHistory from './components/PreviousMonthHistory';
import { useDispatch } from 'react-redux';
import { getAllProjects } from '../../../redux/features/courseSlice';

export default function TutorManagementDashboard() {
  const [modalState, setModalState] = useState({
    actionKey: '',
    row: null,
  });
  const dispatch = useDispatch();

  const modalConfigs = useMemo(
    () => [
      {
        actionKey: 'Previous Month History',
        title: 'Previous Month History',
        render: ({ row }) => <PreviousMonthHistory row={row} />,
        maxWidth: 'xs',
      },
    ],
    [],
  );

  const activeConfig = useMemo(() => {
    if (!modalState.actionKey && !modalState?.row) return null;
    return modalConfigs.find((c) => c?.actionKey === modalState.actionKey) || null;
  }, [modalConfigs, modalState]);

  useEffect(() => {
    dispatch(getAllProjects());
  }, []);

  return (
    <GlobalWrapper title={'Tutor Management Dashboard'}>
      <Stack gap={2}>
        <TutorManagementCardAndTable />
        <SubjectWiseFreeSlot setModalState={setModalState} />
      </Stack>
      <GlobalDialog
        title={activeConfig?.title}
        open={Boolean(modalState?.actionKey)}
        setOpen={(val) => {
          if (!val) setModalState({ actionKey: '', row: null });
        }}
        closeButton={true}
        content={activeConfig?.render ? activeConfig.render({ row: modalState.row }) : null}
        maxWidth={activeConfig?.maxWidth || 'md'}
        sx={activeConfig?.sx}
        fullWidth={true}
      />
    </GlobalWrapper>
  );
}
